import type { User } from '../types/user';

/**
 * FE-35 (ADR-034) — ¿este despliegue tiene finanzas?
 *
 * Lo dice `GET /me` → `features.finance`, y nada más. Se exige `=== true` a
 * propósito: un `User` sin `features` (una sesión vieja, un fixture) se lee
 * como apagado, igual que el core lee la variable ausente. Lo que no se declara
 * no existe.
 */
export function hayFinanzas(user: Pick<User, 'features'> | null | undefined): boolean {
  return user?.features?.finance === true;
}
